import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import i18n from './i18n/index'
import store from './store'
import '@/assets/css/print.css'
import VueMarkdown from 'vue-markdown'
Vue.component('vue-markdown', VueMarkdown)
Vue.config.productionTip = false
//部署正式环境用这个
Vue.prototype.mainHost = "https://" + window.location.host;
Vue.prototype.mainHost1 = "https://" + window.location.host;
//223服务器端口为9001用这个
// Vue.prototype.mainHost = "http://10.12.58.223:8080";
// 223服务器端口为9002用这个
// Vue.prototype.mainHost1 = "http://10.12.58.223:8080";
// 创建全局值转标签过滤器,处理报告下拉框详情展示
Vue.filter('valueToLabel', (value, options) => {
  //  if(!Array.isArray(options)) return value
  if (!value || !options) return ''
  // 查找匹配的选项
    const option = Object.values(options)?.find(opt => 
    opt?.value == value || // 处理数字/字符串类型差异
    String(opt.value) === String(value)
  )
  
  return option ? option.label : ''
})
Vue.use(ElementUI);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAfXTSVkg5hRumPNBbSWhhMjdd3K13YyZY',
    libraries: 'places' // 需要使用的库
  }
});
Vue.config.productionTip = false;


// 异步启动函数
async function initApp() {
  try {
    // 修复语言包加载逻辑
    const path = window.location.hash;
    let requestParams;
    // 检查当前路径是否为登录相关页面
    if (path === '/login' || path === '/verificationLogin') {
      // 登录页和验证页：加载登录专用语言包
      requestParams = { appCategory: 5 };
    } else {
      // 其他页面：加载主应用语言包
      requestParams = { appCategory: null };
    }
    //  requestParams = { appCategory: null };

    await i18n.loadLanguageAsync(requestParams);

    new Vue({
      i18n,
      router,
      store, 
      render: h => h(App),
    }).$mount('#app');

  } catch (error) {
    console.error('应用启动失败:', error);
  }
}

// 启动应用
initApp();